import { Injectable } from '@angular/core';
import { SearchRecord, CriminalSearchTypes, VendorResponseTypes, SearchVendors } from '../models/searchPackage';

@Injectable({
  providedIn: 'root'
})
export class SearchPackageService {
  searchesSupported : Array<SearchRecord> = new Array<SearchRecord>();
  constructor() { 
    // CREDIT 
    let credit = new SearchRecord();
    credit.name = 'Credit';
    credit.searchType = VendorResponseTypes.Credit;
    credit.vendor = SearchVendors.TazWorks;

    // EVICTION
    let eviction = new SearchRecord();
    eviction.name = 'Eviction';
    eviction.searchType = VendorResponseTypes.Eviction;

    // CRIMINAL
    let criminal = new SearchRecord();
    criminal.name = 'Criminal';
    criminal.searchType = VendorResponseTypes.Criminal;
    criminal.vendor = SearchVendors.TazWorks;

    //PERSON
    let person = new SearchRecord();
    person.name = 'PersonSearch';
    person.searchType = VendorResponseTypes.Person
    person.vendor = SearchVendors.TazWorks;

    //TAX LIENs AND JUDGEMENTS
    let blj = new SearchRecord();
    blj.name = 'TaxLien';
    blj.searchType = VendorResponseTypes.TaxLien,
    blj.vendor = SearchVendors.Tracers;


    this.searchesSupported.push(credit);
    this.searchesSupported.push(eviction);
    this.searchesSupported.push(criminal);
    this.searchesSupported.push(person);
    this.searchesSupported.push(blj);
    // console.log(this.searchesSupported);
  }
}
